export function useRootInstance() {
  const vue =
    (document.querySelector('#master-container') as any)?.__vue__ ||
    (document.querySelector('#app') as any)?.__vue__ ||
    new window.Vue({});
  return vue.$root;
}
